var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { BrowserHttpClient } from '@attraqt/http-client-browser';
import { Search as SearchGeneric } from '../search';
export * from '../models';
var SearchBrowser = /** @class */ (function (_super) {
    __extends(SearchBrowser, _super);
    function SearchBrowser() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchBrowser.prototype.init = function (options, httpClient) {
        if (httpClient === void 0) { httpClient = new BrowserHttpClient(window); }
        _super.prototype.init.call(this, options, httpClient);
    };
    return SearchBrowser;
}(SearchGeneric));
// tslint:disable-next-line:variable-name
export var Search = SearchBrowser;
export var search = new SearchBrowser();
export var init = function (options) {
    search.init(options.search);
};
//# sourceMappingURL=browser.js.map